import PropTypes from 'prop-types';
import { useFragment, graphql } from 'react-relay';

import { SbSharedRefineMenuMultiSelectList } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectList.jsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterMovement_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectList_itemSearch
    }
`;

export const SbSharedRefineMenuFilterMovement = ({
    itemSearch: itemSearchRef,
    values,
    filterName,
    collapsedItemCount,
    shouldUseExpandableList,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectList
            itemSearch={itemSearch}
            values={values}
            filterName={filterName}
            collapsedItemCount={collapsedItemCount}
            shouldUseExpandableList={shouldUseExpandableList}
        />
    );
};

SbSharedRefineMenuFilterMovement.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    collapsedItemCount: PropTypes.number,
    shouldUseExpandableList: PropTypes.bool,
};
